import React from 'react';
import { Table, Spin, Icon, Modal, message, Popconfirm } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import dictCache from '../../../common/dictCache';
import ExportUtil from '../../../common/ExportUtil';
import Sider from '../SumEffSider';
import AddLeak from '../AddLeak';
import InvRemark from './InvRemark';
import MoreRemark from './MoreRemark';
import EditAcTableCell from '../EditAcTableCell';
import TransfiniteModal from '../TransfiniteModal';
import Filter from './Filter';
import AdjustRoleFte from './AdjustRoleFte';
import AcLog from './AcLog';
import AcLogTable from './AcLogTable';
import AdjustFte from '../../plan/siteFte/components/AdjustFte';
import moment from 'moment';
import format from '../../shared/format';
import SpecificAdjustFte from './SpecificAdjustFte';

const monthFormat = 'YYYY-MM';
const includes = (str, val) => {
    return (str ? str + '' : '').includes(val + '');
};

class ProjectPercent extends React.Component {
    state = {
        loading: false,
        searchParams: {
            oper: "GE",
            planOper: 'LE'
        },
        list: [],
        pagination: {
            current: 1,
            pageSize: 17,
        },
        count: 0,
        showLeak: false,
        acStatus: "OPEN",
        investigationFinishRemark: [],
        currentDate: null,
        pmAndPa: {},
        isGivenSecondLines: false,
    }

    componentDidMount() {
        this.getDate();
        this.queryPmAndPa();
        this.loadData();
        this.nowAcStatus();
        this.queryInvestigationSecondLines();
    }

    queryInvestigationSecondLines = () => {
        //判断是否为执行业务线二级分类为“SSU主导、启动前协助、启动前协助+启动后常规CRC执行、启动后常规CRC执行、非盲”的项目
        const investigationId = sessionStorage.invId || this.props.invId;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationSecondLines,
            data: { invId: investigationId },
            dataType: 'json',
            doneResult: res => {
                const { secondLines, sitePlanFteCal } = res;
                const givenSecondLines = ['SSU主导','启动前协助','启动前协助+启动后常规CRC执行','启动后常规CRC执行','非盲'];
                const isGivenSecondLines = givenSecondLines.includes(secondLines) && sitePlanFteCal;
                this.setState({
                    isGivenSecondLines,
                });
            }
        };
        $.sendRequest(options);
    }

    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            this.setState({ currentDate: date });
        });
    }

    queryPmAndPa = () => {
        const investigationId = sessionStorage.invId || this.props.invId;
        const options = {
            method: 'POST',
            url: API_URL.common.queryPmAndPa,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                this.setState({ pmAndPa: res.data || {} });
            }
        };
        $.sendRequest(options);
    }

    loadData = (params = {}) => {
        this.setState({
            list: [],
            loading: true,
        });
        const { invId } = this.props;
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { childCode, investigationSiteId, userId } = searchParams;
        const isEmpty = !childCode && !investigationSiteId && !userId;
        const options = {
            method: 'POST',
            url: API_URL.sumtotal.queryInvestigationFinishedPercentage,
            data: {
                offset: current,
                limit: isEmpty ? pageSize - 8 : pageSize,
                investigationId: invId,
                ...searchParams,
                ...params,
            },
            dataType: 'json',
            doneResult: (res => {
                const totalCount = res.totalCount;
                const ct = Math.floor(totalCount / (pageSize - 8)) * pageSize + (totalCount % (pageSize - 8) && (totalCount % (pageSize - 8) + 8));
                pagination.total = isEmpty ? ct : totalCount;

                let investigationFinishRemark;
                if (res.datas && res.datas.length > 0) {
                    investigationFinishRemark = res.datas[0].investigationFinishRemarks;
                }
                this.setState({
                    loading: false,
                    list: res.datas,
                    count: res.count,
                    pagination,
                    investigationFinishRemark,
                });
            }),
            errorResult: (() => {
                this.setState({ loading: false, });
            }),
        };
        $.sendRequest(options);
    }

    search = (params) => {
        const { pagination } = this.state;
        const { childCode, investigationSiteId, userId } = params;
        const isEmpty = !childCode && !investigationSiteId && !userId;
        pagination.current = 1;
        pagination.pageSize = isEmpty ? 17 : 10;
        this.setState({
            pagination,
            searchParams: {
                ...params,
            },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { invId } = this.props;
        const { searchParams, pagination } = this.state;
        let url = `${API_URL.sumtotal.exportInvestigationFinishedPercentage}`;
        if (invId) {
            searchParams.investigationId = invId;
        }
        ExportUtil.export({
            ...searchParams,
            offset: pagination.current,
            limit: pagination.pageSize - 8,
        }, pagination, url);
    }

    toggleConfirm = (status, investigationId) => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: status == 'CLOSE' ? `确定要关闭AC自动调整?` : `确定要打开AC自动调整?`,
            onOk: () => {
                this.toggleAC(status, investigationId);
            },
        });
    }

    toggleAC = (status, investigationId) => {
        const { invId } = sessionStorage;
        const { invId: invIdProps } = this.props;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: `${API_URL.sumtotal.setInvestigationAc}`,
            data: {
                status,
                investigationId: investigationId || (invId > 0 ? invId : invIdProps),
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.nowAcStatus();
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    remarkDelete = (investigationId, investigationFinishRemarkId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.common.deleteInvestigationFinishRemark,
            data: {
                investigationId,
                investigationFinishRemarkId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    renders = (value, row, index) => {
        const obj = {
            children: value,
            props: {},
        };
        const { count, searchParams } = this.state;
        const { childCode, investigationSiteId, userId } = searchParams;
        const isEmpty = !childCode && !investigationSiteId && !userId;
        if (!isEmpty) {
            return obj;
        }
        if (count == 17 && index > 9) {
            obj.props.colSpan = 0;
        } else if (count >= 8 && count < 17) {
            if (index == count - 7) {
                obj.props.colSpan = 0;
                obj.props.rowSpan = 7;
            } else if (index > count - 7) {
                obj.props.colSpan = 0;
                obj.props.rowSpan = 0;
            }
        }
        return obj;
    }

    renderContent = (value, row, index) => {
        const obj = {
            children: value,
            props: {},
        };
        const { count, searchParams } = this.state;
        const { childCode, investigationSiteId, userId } = searchParams;
        const isEmpty = !childCode && !investigationSiteId && !userId;
        if (isEmpty) {
            if (count == 17 && index > 9) {
                obj.props.colSpan = 0;
            } else if (count != 17 && index > count - 8) {
                obj.props.colSpan = 0;
            }
        }
        if (row.startTimeStr && row.startTimeStr.length > 0) {
            const array = row.startTimeStr.split(';');
            const result = array.map((item, index) => (<span key={index}>{item}；<br /></span>));
            row.startTimeStr = <span>{result}</span>;
        }
        if (row.endTimeStr && row.endTimeStr.length > 0) {
            const array = row.endTimeStr.split(';');
            const result = array.map((item, index) => (<span key={index}>{item}；<br /></span>));
            row.endTimeStr = <span>{result}</span>;
        }
        if (row.contractTypeValue && Array.isArray(row.contractTypeValue) && row.contractTypeValue.length > 0) {
            const array = row.contractTypeValue.split(';');
            const result = array.map((item, index) => (<span key={index}>{item}；<br /></span>));
            row.contractTypeValue = <span>{result}</span>;
        }

        return obj;
    }

    renderDom = () => {
        const { investigationFinishRemark = [] } = this.state
        const { curRole, invId } = sessionStorage;
        const { jde, invId: invIdProps } = this.props;
        let investigationId = jde ? invIdProps : invId;
        const isShow = curRole === 'PM' ||  curRole === 'PML' || curRole === 'BO' || curRole === 'TAL';
        return (
            <div style={{ padding: '20px 40px' }}>
                  {
                    isShow &&
                    <span style={{ position: 'absolute', top: 20, right: 100, color: '#0e77ca', cursor: 'pointer' }} onClick={() => this.showAcLogTable(investigationId)}>
                        AC开关日志
                    </span>
                }
                {
                    isShow &&
                    <span style={{ position: 'absolute', top: 20, right: 40, color: '#0e77ca', cursor: 'pointer' }} onClick={() => this.showInvRemark(investigationId)}>
                        添加备注
                    </span>
                }
                
                {
                    investigationFinishRemark.length > 0 ?
                        investigationFinishRemark.slice(0, 3).map((d, index) =>
                            <div key={d.investigationFinishRemarkId} style={(investigationFinishRemark.slice(0, 3).length != (index + 1)) ? { borderBottom: "2px dashed #d6d4d4" } : null}>
                                <p style={{ textAlign: 'left', paddingTop: 5 }}>{format('joint', d.userName, d.modifyTime, 'roundBrackets')}
                                    {
                                        (isShow && d.type !== 'INV_TIME_UPDATE') &&
                                        <Popconfirm title='确认要删除吗?' onConfirm={() => this.remarkDelete(investigationId, d.investigationFinishRemarkId)} okText="确定" cancelText="取消">
                                            <Icon type="close"
                                                style={{ color: "red", position: "relative", top: 3, float: "right", cursor: "pointer" }}
                                            />
                                        </Popconfirm>
                                    }
                                </p>
                                <p style={{ textAlign: 'left', paddingBottom: 15 }} className="tableRemark">{d.remark}</p>
                            </div>)
                        : ''
                }
                {
                    (investigationFinishRemark.length > 2) &&
                    <span style={{ position: 'absolute', bottom: 20, right: 40, color: '#0e77ca', cursor: 'pointer' }} onClick={this.showMoreRemark}>
                        查看更多&gt;&gt;
                    </span>
                }
            </div>
        )
    }

    getColumns = () => {
        const { invId } = this.props;
        const { list, count, searchParams, currentDate, pmAndPa } = this.state;
        const [{ ftes } = {}] = list || [];
        const { curRole, userId: uId } = sessionStorage;
        const { isGivenSecondLines } = this.state;
        const isShow = curRole == 'CRCM';
        const { childCode, investigationSiteId, userId } = searchParams;
        const isEmpty = !childCode && !investigationSiteId && !userId;              // 有搜索条件时不需要合并

        const { paId, palId, pmId, pmlId } = pmAndPa;
        const isPA = includes(paId, uId) || includes(palId, uId);
        const isPM = includes(pmId, uId);
        const isPML = includes(pmlId, uId);

        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
            render: !isShow ?
                (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (!isEmpty) {
                        return obj;
                    }
                    if (count >= 8) {
                        if (index == count - 7) {
                            obj.props.colSpan = 7;
                            obj.props.rowSpan = 7;
                            obj.children = this.renderDom();
                        } else if (index > count - 7) {
                            obj.props.colSpan = 7;
                            obj.props.rowSpan = 0;
                        }
                    }
                    return obj;
                }
                : this.renderContent
        }, {
            title: 'JDE主项目号',
            width: 105,
            dataIndex: 'mainCode',
            key: 'mainCode',
            render: this.renders,
        }, {
            title: 'JDE项目号',
            width: 200,
            dataIndex: 'childCode',
            key: 'childCode',
            render: this.renders,
        }, {
            title: '计收入确认方式',
            width: 105,
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            render: this.renders,
        }, {
            title: '合同开始时间',
            width: 110,
            dataIndex: 'startTimeStr',
            key: 'startTimeStr',
            render: this.renders,
        }, {
            title: '合同结束时间',
            width: 110,
            dataIndex: 'endTimeStr',
            key: 'endTimeStr',
            render: this.renders,
        }, {
            title: '项目计划结束时间',
            width: 135,
            dataIndex: 'investigationPlanEndTimeString',
            key: 'investigationPlanEndTimeString',
            render: this.renders,
        }, {
            title: '中心编号',
            width: 85,
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            render: this.renderContent,
        }, {
            title: '中心名称',
            width: 170,
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            render: this.renderContent,
        }, {
            title: '人员工号',
            width: 100,
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            render: (text, record, index) => {
                const { employeeCode, roleCode } = record;
                const roleCodeStr = roleCode ? `(${roleCode})` : '';
                text = employeeCode ? `${employeeCode}${roleCodeStr}` : '';
                return this.renderContent(text, record, index);
            }
        }, {
            title: '人员姓名',
            width: 85,
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            render: (text, row, index) => {
                if (row.userId < 0) {
                    return {
                        children: <span style={{ textAlign: 'right', display: 'block' }}>{text}</span>,
                        props: {
                            colSpan: !isShow ? 4 : 11,
                        },
                    };
                } else {
                    return <span>{text}</span>;
                }
            },
        }];

        (ftes || []).forEach((d, i) => {
            if (i < ftes.length - 2) {
                // 检查是否是未来月份
                columns.push({
                    title: d.title,
                    dataIndex: `fteValue${i}`,
                    key: `fteValue${i}`,
                    width: 140,
                    render: (text, row, index) => {
                        const {
                            ftes, investigationId, investigationSiteId, investigationSiteName, investigationSiteCode,
                            userId, userCompellation, employeeCode, roleCode
                        } = row;
                        const { title, date, fteValue, locked, edited } = (ftes || [])[i];
                        const isRed = row[`fteValue${i}isRed`] == '1';

                        if (investigationSiteCode == 'AC') {
                            const isEdit = this.state[`fteValue${i}isEdit`];
                            return (
                                <div style={{ width: isEdit && 85 }}>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            paddingLeft: 8,
                                            lineHeight: '50px',
                                            color: isRed && "#F00",
                                            background: edited && '#f7f705',
                                        }}
                                    >
                                        {
                                            (curRole == 'BO' || curRole == 'CTA') ?
                                                <div>
                                                    {
                                                        locked ?
                                                            <div>
                                                                {text}
                                                                <Icon type="lock" style={{ position: 'absolute', right: 4, bottom: 4, fontSize: '12px' }} />
                                                            </div>
                                                            :
                                                            <EditAcTableCell text={text} record={row} invId={invId} colNum={i} loadData={this.loadData} saveCellEdit={this.saveCellEdit} />
                                                    }
                                                </div>
                                                :
                                                text
                                        }
                                    </div>
                                    <div style={{ height: 30 }}></div>
                                </div>
                            );
                        } else {
                            let showEditableMask = (!isEmpty || index < count - 8) && this.computeIsShowMask(date, currentDate);
                            let role_editable = false;
                            let func = () => {};
                            if (isPA || isPM || isPML) {
                                if (investigationSiteId) {
                                    role_editable = true;
                                    func = () => this.adjustFte({title, date, investigationSiteId, investigationSiteName, investigationSiteCode});
                                } else if (userId) {
                                    if ((roleCode === 'PA' && (isPM || isPA)) || (roleCode === 'PM' && (isPM || isPML))) {
                                        role_editable = true;
                                        func = () => this.adjustRoleFte({ date, fteValue, userId, userCompellation, employeeCode, roleCode, investigationSiteId, investigationId });
                                    }
                                }
                            }
                            return (
                                <div style={{ color: isRed && '#F00' }}>
                                    {
                                        showEditableMask && role_editable && !isGivenSecondLines && 
                                        <div className="editableCell">
                                            <Icon
                                                type="edit"
                                                onClick={func}
                                            />
                                        </div>
                                    }
                                    {text}
                                </div>
                            );
                        }
                    }
                });
            } else {
                columns.push({
                    title: d.title,
                    dataIndex: `fteValue${i}`,
                    key: `fteValue${i}`,
                    width: 70,
                    fixed: 'right',
                    render: (text, row, index) => {
                        let fteValue = "-";
                        if (row.investigationSiteCode == 'AC') {
                            const { ftes = [] } = row;
                            fteValue = ftes && ftes[i].fteValue;
                            if (!fteValue) {
                                return <span>-</span>;
                            } else {
                                return <span>{fteValue}</span>;
                            }
                        } else {
                            return <span>{text}</span>;
                        }
                    }
                });
            }
        });
        return columns;
    }

    /**
     * 判断FTE日期是否能编辑
     * 1、年月相同，当前日期小于26内
     * 2、年月不相同，FTE日期大于当前日期
     * @param {*} date FTE日期
     * @param {*} curDate 当前日期
     * @return 是否可编辑
     */
    computeIsShowMask = (date, curDate) => {
        const dateObj = moment(date).add(1, 'M').subtract(1, 'd');
        const curDateObj = moment(curDate);

        return (
            dateObj.format(monthFormat) === curDateObj.format(monthFormat) ?
                curDateObj.date() < 26
            :
                dateObj.valueOf() > curDateObj.valueOf()
        );
    }

    saveCellEdit = (key, value) => {
        this.setState({ [key]: value });
    }

    getDataSource = () => {
        const { list, pagination: { current, pageSize }, searchParams } = this.state;
        const { childCode, investigationSiteId, userId } = searchParams;
        const isEmpty = !childCode && !investigationSiteId && !userId;
        const dataSource = list.map((dataItem, i) => {
            const ftelist = {};
            (dataItem.ftes || []).map((d, j) => {
                ftelist[`fteValue${j}`] = d.fteValue;
                ftelist[`fteValue${j}isRed`] = d.isRed;
            });
            return {
                index: (current - 1) * (isEmpty ? (pageSize - 7) : pageSize) + i + 1,
                ...dataItem,
                ...ftelist,
            };
        })
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    nowAcStatus = () => {
        const { invId } = this.props;
        const optionsForAc = {
            url: API_URL.sumtotal.queryInvestigationAcById,
            data: { investigationId: invId },
            dataType: 'json',
            doneResult: (res => {
                if (res.data && res.data.status == "CLOSE") {
                    this.setState({ acStatus: "CLOSE" });
                } else {
                    this.setState({ acStatus: "OPEN" });
                }
            })
        };
        $.sendRequest(optionsForAc);
    }

    toggleLeak = (showLeak) => {
        this.setState({ showLeak });
    }

    showInvRemark = (investigationId) => {
        this.invRemarkRef.show(investigationId);
    }

    showAcLogTable = (investigationId)=>{
        this.acLogTableRef.show(investigationId)
    }

    showMoreRemark = () => {
        const { investigationFinishRemark: list = [] } = this.state;
        const { invId } = sessionStorage;
        this.moreRemarkRef.show((list[0] && list[0].investigationId) || invId);
    }

    showTransfiniteModal = () => {
        const { invId: invIdProps } = this.props;
        const { invId } = sessionStorage;
        this.transfiniteModalRef.show(invId > 0 ? invId : invIdProps);
    }

    adjustFte = (record) => {
        const { invId, invState } = sessionStorage;
        const { invId: detailInvId } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationSecondLines,
            data: { invId: invState == 0 ? detailInvId : invId  },
            dataType: 'json',
            doneResult: res => {
                const { secondLines, sitePlanFteCal } = res;
                const givenSecondLines = ['SSU主导','启动前协助','启动前协助+启动后常规CRC执行','启动后常规CRC执行','非盲'];
                const isGivenSecondLines = givenSecondLines.includes(secondLines) && sitePlanFteCal;
                //判断是否为执行业务线二级分类为“SSU主导、启动前协助、启动前协助+启动后常规CRC执行、启动后常规CRC执行、非盲”的项目
                if (isGivenSecondLines) {
                    this.specificAdjustFteRef.show(record);
                } else {
                    this.fteRef.show(record);
                }
            }
        };
        $.sendRequest(options);
    }

    adjustRoleFte = (record) => {
        this.roleFteRef.show(record);
    }

    acLog = (investigationId,opStatus) => {
        this.acLogRef.show(investigationId,opStatus);
    }

    render() {
        const { jde, invId } = this.props;
        const {
            loading,
            pagination,
            list,
            showLeak,
            acStatus,
            investigationFinishRemark,
        } = this.state;
        const xscroll = (list[0] ? (list[0].ftes.length - 2) * 140 + 140 : 0) + 1175;
        const { scrollY } = this.props;
        return (
            <div className="content project-percent">
                {!jde && <Sider selectKey='percent' />}
                <div className="main" style={{ minHeight: "400px", display: !showLeak ? "block" : "none" }}>
                    {
                        !showLeak ?
                            <Spin spinning={jde ? loading : false}>
                                <Filter
                                    invId={invId}
                                    acStatus={acStatus}
                                    search={this.search}
                                    export={this.export}
                                    toggleLeak={value => this.toggleLeak(value)}
                                    showTransfiniteModal={this.showTransfiniteModal}
                                    toggleConfirm={status => this.toggleConfirm(status)}
                                    showAcLog={this.acLog}
                                    list={list}
                                    
                                />
                                <div className="main-content">
                                    <Table
                                        columns={this.getColumns()}
                                        dataSource={this.getDataSource()}
                                        rowKey={record => record.inestigationSiteWeekSummaryId}
                                        loading={jde ? false : loading}
                                        scroll={{ x: xscroll, y: scrollY || 550 }}
                                        pagination={pagination}
                                        onChange={this.handleTableChange}
                                    />
                                </div>
                            </Spin>
                        :
                            <AddLeak toggleLeak={value => this.toggleLeak(value)} />
                    }
                </div>
                <InvRemark ref={el => this.invRemarkRef = el} loadData={this.loadData} />
                <MoreRemark ref={el => this.moreRemarkRef = el} list={investigationFinishRemark || []} loadData={this.loadData} />
                <TransfiniteModal ref={el => this.transfiniteModalRef = el} loadData={this.loadData} />
                <AdjustFte ref={el => this.fteRef = el} loadData={this.loadData} />
                <AdjustRoleFte ref={el => this.roleFteRef = el} loadData={this.loadData} />
                <SpecificAdjustFte detailInvId={invId} ref={el => this.specificAdjustFteRef = el} loadData={this.loadData} />
                <AcLog ref={el => this.acLogRef = el} loadData={this.loadData} nowAcStatus={this.nowAcStatus}/>
                <AcLogTable ref={el => this.acLogTableRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

export default ProjectPercent;


// WEBPACK FOOTER //
// ./src/components/sumTotal/projectPercent/index.js